export const GRIBBLE_CONTRACT_ADDRESS = process.env.REACT_APP_GRIBBLE_CONTRACT_ADDRESS!;
export const BREAKER_CONTRACT_ADDRESS = process.env.REACT_APP_BREAKER_CONTRACT_ADDRESS!;

export function getMoralisNetworkChain(): 'eth' | 'goerli' {
  if (process.env.REACT_APP_EGG_CHAIN === 'eth') {
    return process.env.REACT_APP_EGG_CHAIN;
  }
  return 'goerli';
}
